// @flow
import PubSub from 'pubsub-js'
import { type Store } from 'effector'
import { createGate } from 'effector-react'
import { equals } from 'ramda'

import { STORE_NAME } from '../data'
import { VALUES_CHANGED } from '../pubsub'
import { getStorageValues } from '../utils'
import type { FormSpyValues } from '../types'

import { SpyDomain } from './domain'
import { loadSpyValues, removeSpyValue, saveUserFormValues, setSpyValues } from './events'

SpyDomain.onCreateStore(async (store) => {
  if (store.shortName !== STORE_NAME) return

  const valuesFromStorage = await loadSpyValues()

  store.setState(valuesFromStorage)
})

const $formSpyValues: Store<FormSpyValues> = SpyDomain.store(getStorageValues(), { name: STORE_NAME })

const $formSpyUpdates: Store<FormSpyValues> = $formSpyValues.map((state, prevState?: FormSpyValues) => {
  if (!prevState || !equals(state, prevState)) {
    return state
  }

  return prevState
})

const FormManagerGate = createGate<{}>()

$formSpyValues
  .on(removeSpyValue, (state, key) => {
    const { [key]: deletedKey, ...newState } = state

    return newState
  })
  .on(setSpyValues, (state, values) => {
    const addState = values

    return { ...state, ...addState }
  })

$formSpyValues.updates.watch((values) => {
  PubSub.publish(VALUES_CHANGED, values)
})

$formSpyUpdates.updates.watch((values) => {
  saveUserFormValues(values)
})

export { $formSpyValues, FormManagerGate }
